import { styled, Text } from '@obvio/app'
import { ForgotPasswordForm } from '@obvio/template'
import { Stack } from '@obvio/ui'

import type { ReactElement } from 'react'

type SignTitleProps = {
  title: string
  description: string
}

const Title = styled(Text)`
  font-size: 3rem;
  line-height: 100%;
`

const Description = styled(Text)`
  font-size: 0.8125rem;
  line-height: 150%;
  letter-spacing: 0.025rem;
`

const CenteredStack = styled(Stack)`
  text-align: center;
`

export const PasswordForm = styled(ForgotPasswordForm)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  button {
    margin-top: 0;
  }
  > a {
    margin-top: 0;
  }
`

export function SignTitle({
  description,
  title,
}: SignTitleProps): ReactElement {
  return (
    <CenteredStack kind="vertical" spacing="small">
      <Title tag="h1">{title}</Title>
      <Description>{description}</Description>
    </CenteredStack>
  )
}
